import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  ISalesInvoicePaymentsDto,
  ISalesInvoicePaymentsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISalesInvoicePaymentsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.salesInvoices.payments");
const postApis = createPostApi<
  IApiResponse<ISalesInvoicePaymentsResponse>,
  IPathBaseParam,
  ISalesInvoicePaymentsDto
>("stores.salesInvoices.payments");

const getApis = createGetApi<
  IApiResponse<ISalesInvoicePaymentsResponse>,
  IPathByIdParam,
  object
>("stores.salesInvoices.payments");

export const payments = {
  ...getAllApis,
  ...getApis,
  ...postApis,
};
